import { render, staticRenderFns } from "./magic.vue?vue&type=template&id=b20896ba&scoped=true"
import script from "./magic.vue?vue&type=script&lang=js"
export * from "./magic.vue?vue&type=script&lang=js"
import style0 from "./magic.vue?vue&type=style&index=0&id=b20896ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20896ba",
  null
  
)

export default component.exports